import { QueryClient } from '@tanstack/react-query';

/**
 * Retrying a 401/403/404 is pointless and, worse, noisy: a scope 404 is a *correct*
 * answer from the API (docs/03 §4 — another section's document does not exist as far as
 * this caller is concerned), so hammering it three more times only delays the empty
 * state. Retry the ones that can genuinely be transient.
 */
const shouldRetry = (failureCount, error) => {
  const status = error?.status ?? 0;
  if ([400, 401, 403, 404, 409, 422].includes(status)) return false;
  return failureCount < 2;
};

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        // Financial figures go stale the moment someone else posts an entry, so the
        // window is short — but not zero, or every tab focus re-runs a trial balance.
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: false, // never replay a money mutation automatically
      },
    },
  });

export default createQueryClient;
